const SDK_CSS_URL = 'https://atlas.microsoft.com/sdk/javascript/mapcontrol/3/atlas.min.css';
const SDK_JS_URL = 'https://atlas.microsoft.com/sdk/javascript/mapcontrol/3/atlas.min.js';

let sdkPromise = null;

function ensureCss() {
  const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).find((link) => link.href === SDK_CSS_URL);
  if (existing) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = SDK_CSS_URL;
  link.type = 'text/css';
  document.head.appendChild(link);
}

export function ensureAzureMapsSdk() {
  if (typeof window !== 'undefined' && window.atlas) {
    return Promise.resolve(window.atlas);
  }

  if (sdkPromise) {
    return sdkPromise;
  }

  sdkPromise = new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('Azure Maps SDK solo puede cargarse en el navegador.'));
      return;
    }

    ensureCss();

    const existingScript = Array.from(document.querySelectorAll('script')).find((script) => script.src === SDK_JS_URL);
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.atlas));
      existingScript.addEventListener('error', () => reject(new Error('No se pudo cargar Azure Maps SDK.')));
      return;
    }

    const script = document.createElement('script');
    script.src = SDK_JS_URL;
    script.async = true;
    script.onload = () => resolve(window.atlas);
    script.onerror = () => reject(new Error('No se pudo cargar Azure Maps SDK.'));
    document.head.appendChild(script);
  });

  return sdkPromise;
}
